<template>
  <!-- 宿舍房态图 -->
  <div class="my_viewLivingQuartersChart"
       :style="{'--bed_bg_color':colorObj.bed_bg_color,
  '--bed_font_color':colorObj.bed_font_color,
  '--building_not_sel_font_color':colorObj.building_not_sel_font_color,
  '--building_sel_bg_color':colorObj.building_sel_bg_color,
  '--building_sel_font_color':colorObj.building_sel_font_color,
  '--dorm_top_bg_color':colorObj.dorm_top_bg_color,
  '--dorm_top_font_color':colorObj.dorm_top_font_color,
  '--empty_bed_bg_color':colorObj.empty_bed_bg_color,
  '--in_bed_bg_color':colorObj.in_bed_bg_color,
  '--in_bed_empname_font_color':colorObj.in_bed_empname_font_color,
  '--not_in_bed_bg_color':colorObj.not_in_bed_bg_color
  }">
    <van-nav-bar :title="'宿舍房态图'"
                 left-text=""
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true">
    </van-nav-bar>
    <div class="content">
      <div class="query_box">
        <div class="area_box"
             @click="showFloorsPicker = true">
          <van-field v-model="areaTxt"
                     readonly />
          <van-icon name="arrow" />
        </div>
        <div class="show_empty">
          <van-switch v-model="just_show_empty"
                      size="24px"
                      active-color="#07C160"
                      @change="changeFilterConditions" />
          <span class="swi_label">{{'显示空床位'}}</span>
        </div>
      </div>
      <div class="query_box">
        <van-dropdown-menu class="select_dormtype">
          <van-dropdown-item title="请选择属性"
                             ref="dormtypeItem">
            <van-checkbox-group v-model="dormtype">
              <van-cell v-for="dot in dormtypelist"
                        :key="dot.dicvalue"
                        clickable>
                <template #title>
                  <van-checkbox shape="square"
                                :name="dot.dicvalue">{{ dot.dicvalue }}</van-checkbox>
                </template>
              </van-cell>
            </van-checkbox-group>
            <div style="padding: 5px 16px;">
              <van-button type="info"
                          block
                          round
                          size="small"
                          @click="changeFilterConditions('type')"> {{ $t('module.confirm') }} </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
        <van-dropdown-menu class="select_dormtype">
          <van-dropdown-item title="请选择分类"
                             ref="dormcatalogItem">
            <van-checkbox-group v-model="dormcatalog">
              <van-cell v-for="doc in dormcataloglist"
                        :key="doc.dicvalue"
                        clickable>
                <template #title>
                  <van-checkbox shape="square"
                                :name="doc.dicvalue">{{ doc.dicvalue }}</van-checkbox>
                </template>
              </van-cell>
            </van-checkbox-group>
            <div style="padding: 5px 16px;">
              <van-button type="info"
                          block
                          round
                          size="small"
                          @click="changeFilterConditions('catalog')"> {{ $t('module.confirm') }} </van-button>
            </div>
          </van-dropdown-item>
        </van-dropdown-menu>
      </div>
      <div class="room_box">
        <div class="room_content"
             v-for="(room,ri) in roomList"
             :key="'ro'+ri">
          <div class="room_title">
            <div class="left_mark mark">{{ room.dormno }}</div>
            <div class="middle_mark mark">{{ room.dormtype }}</div>
            <div class="right_mark mark">{{ room.dormcatalog }}</div>
          </div>
          <div class="bed_box">
            <div class="many_beds">
              <!-- 高度等于总高度除以行数 -->
              <div class="bed"
                   v-for="(bed,bi) in room.bedList"
                   :key="'bed'+bi"
                   :style="{height:8.58667/room.rows+'rem'}">
                <div class="bed_con"
                     :class="{'check_in':bed.isin,'no_check':!bed.isin,'empty_box':bed.empty}">
                  <van-tag v-if="bed.bedno"
                           type="primary"
                           style="width:30px">{{bed.bedno}}</van-tag>
                  <div class="epmname">{{bed.empname}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="roomList.length == 0"
             class="empty-data"
             style="font-size:16px;text-align: center; height: 100px; width: 100%; line-height: 100px;">
          {{ $t('module.NoData') }}
        </div>
      </div>
    </div>
    <!-- 选择楼层数据 -->
    <van-popup v-model="showFloorsPicker"
               position="bottom"
               round>
      <van-picker show-toolbar
                  :loading="loading"
                  :title="'区域选择'"
                  :columns="floorList"
                  :value-key="'keyname'"
                  @confirm="onFloorsPickerConfirm"
                  @cancel="showFloorsPicker = false">
      </van-picker>
    </van-popup>
  </div>
</template>

<script>
import { getCommTreeData } from "@api/wxjx.js";
import { getDromAreaFloorConfig, getFloorBedInfo, } from '@api/wx.js'
export default {
  data () {
    const userInfo = localStorage.userInfo ? JSON.parse(localStorage.userInfo) : {};
    const query = this.$route.query
    let areaTxt = query.areaData ? query.areaData : ''
    let floorid = query.floorid
    let buildingid = query.buildingid
    return {
      userInfo,
      areaTxt,
      buildingid,
      floorid,
      floorList: [], // 楼层区域
      showFloorsPicker: false,
      loading: true,
      just_show_empty: false,
      initialColorconfig: {},
      roomList: [],
      dormtype: [],
      dormtypelist: [],
      dormcatalog: [],
      dormcataloglist: []
    }
  },
  computed: {
    // 各种颜色
    colorObj () {
      const obj = {}
      if (this.initialColorconfig)
      {
        obj.bed_bg_color = this.colorToHex(this.initialColorconfig.bed_bg_color)
        obj.bed_font_color = this.colorToHex(this.initialColorconfig.bed_font_color)
        obj.building_not_sel_font_color = this.colorToHex(this.initialColorconfig.building_not_sel_font_color)
        obj.building_sel_bg_color = this.colorToHex(this.initialColorconfig.building_sel_bg_color)
        obj.building_sel_font_color = this.colorToHex(this.initialColorconfig.building_sel_font_color)
        obj.dorm_top_bg_color = this.colorToHex(this.initialColorconfig.dorm_top_bg_color)
        obj.dorm_top_font_color = this.colorToHex(this.initialColorconfig.dorm_top_font_color)
        obj.empty_bed_bg_color = this.colorToHex(this.initialColorconfig.empty_bed_bg_color)
        obj.in_bed_bg_color = this.colorToHex(this.initialColorconfig.in_bed_bg_color)
        obj.in_bed_empname_font_color = this.colorToHex(this.initialColorconfig.in_bed_empname_font_color)
        obj.not_in_bed_bg_color = this.colorToHex(this.initialColorconfig.not_in_bed_bg_color)
      }
      return obj
    }
  },
  watch: {
    // 区域弹窗
    showFloorsPicker (n) {
      if (n)
      {
        this.getTreeData();
      } else
      {
        this.loading = true
      }
    }
  },
  created () {
    const query = this.$route.query
    this.areaTxt = query.areaData ? query.areaData : ''
    this.floorid = query.floorid
    this.buildingid = query.buildingid
    this.getDromAreaFloorConfigData()
    this.getFloorBedInfoData(this.floorid, this.buildingid)
  },
  methods: {
    // 切换右上角过滤条件时
    changeFilterConditions (val) {
      if (val == 'type')
      {
        this.$refs.dormtypeItem.toggle();
      } else if (val == 'catalog')
      {
        this.$refs.dormcatalogItem.toggle();
      }
      this.getFloorBedInfoData(this.floorid, this.buildingid)
    },
    // 获取某个楼层所有宿舍的床位信息
    getFloorBedInfoData (floorId, buildingid) {
      getFloorBedInfo({
        buildingid: buildingid,
        floorid: floorId,
        username: this.userInfo.username,
        just_show_empty: this.just_show_empty,
        dormtype: this.dormtype.length > 0 ? this.dormtype.join(',') : '',
        dormcatalog: this.dormcatalog.length > 0 ? this.dormcatalog.join(',') : ''
      }).then(res => {
        const bedinfo = res.bedinfo
        this.roomList = res.dorminfo
        this.roomList.forEach(el => {
          el.bedList = bedinfo.filter(it => it.mautoid == el.autoid)
          if (el.bedList.length < 4)
          {
            el.rows = 2
            const len = 4 - el.bedList.length
            for (let i = 0; i < len; i++)
            {
              el.bedList.push({
                autoid: 0,
                bedno: 0,
                empcode: "",
                empid: 0,
                empname: "",
                indate: "",
                isin: false,
                mautoid: el.autoid,
                empty: true
              })
            }
          } else
          {
            el.rows = Math.ceil(el.bedList.length / 2)
            // 奇数就添加一个空白
            if (el.bedList.length % 2 !== 0)
            {
              el.bedList.push({
                autoid: 0,
                bedno: 0,
                empcode: "",
                empid: 0,
                empname: "",
                indate: "",
                isin: false,
                mautoid: el.autoid,
                empty: true
              })
            }
          }
        });
        // console.log(roomList.value, 'roomList.value');
      })
    },
    // 获取宿舍房态图区域楼栋楼层和颜色配置信息
    getDromAreaFloorConfigData () {
      getDromAreaFloorConfig({
        username: this.userInfo.username
      }).then(res => {
        this.initialColorconfig = res.colorconfig ? res.colorconfig[0] : {}
        this.dormtypelist = res.dormtypelist
        this.dormcataloglist = res.dormcataloglist
      })
    },
    // 选中楼层回调
    onFloorsPickerConfirm (val, keys) {
      this.areaTxt = val.join('/')
      const floor = this.floorList[keys[0]].children[keys[1]].children[keys[2]]
      this.floorid = this.floorList[keys[0]].children[keys[1]].children[keys[2]].autoid
      this.buildingid = this.floorList[keys[0]].children[keys[1]].children[keys[2]].buildingid
      this.getFloorBedInfoData(this.floorid, this.buildingid)
      this.showFloorsPicker = false
    },
    // 获取数据区域楼栋楼层信息接口
    getTreeData () {
      getCommTreeData({
        moduleno: 908,
        treename: 'dormtree',
        username: this.userInfo.username,
        fieldname: 'wx_dorm_area',
        editstate: 3,
        formstr: ''
      }).then(res => {
        let list = res.data || []
        // 只需要1,2,3级数据
        list = list.filter(it => { return it.levelid != 0 && it.levelid != 4 })
        let map = {}, node, tree = [], i;
        for (i = 0; i < list.length; i++)
        {
          if (list[i].parentid == 0)
          {
            list[i].parentid = null
          }
          map[list[i].autoid] = i; // 初始化映射
          if (list[i].levelid != 3)
          {
            list[i].children = []; // 初始化children数组
          }
        }
        for (i = 0; i < list.length; i++)
        {
          node = list[i];
          if (node.parentid !== null)
          {
            // 如果当前节点有父节点，则找到父节点的位置并将当前节点添加到父节点的children数组中
            list[map[node.parentid]].children.push(node);
          } else
          {
            // 如果当前节点没有父节点，则将其添加到树的顶层
            tree.push(node);
          }
        }
        this.floorList = tree
        // 去掉没有楼栋的区域
        let newDong = []
        this.floorList.forEach(it => {
          if (it.children.length != 0)
          {
            newDong.push(it)
          }
        })
        this.floorList = newDong
        // 去掉没有楼层的楼栋
        this.floorList.forEach(it => {
          let newChilds = []
          it.children.forEach(item => {
            if (item.children.length != 0)
            {
              newChilds.push(item)
            }
          });
          it.children = newChilds
        });
        // console.log(tree, 'addChildren');
        this.loading = false
      })
    },
    // 十进制数字转HEX
    colorToHex (color) {
      if (color || color == 0)
      {
        if (typeof color != "string")
        {
          color = "#" + Math.abs(color).toString(16).padStart(6, 0);
        }
      } else
      {
        color = "";
      }
      return color;
    },
    // 返回
    onClickLeft () {
      if (this.$route.query.from == 'home')
      {
        this.$router.push('/home')
      } else
      {
        this.$router.push('/personCen')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.my_viewLivingQuartersChart {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;
    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
    /deep/.van-nav-bar__right {
      font-size: 28px;
      .van-nav-bar__text {
        color: #fff;
      }
    }
  }
  .content {
    // overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .query_box {
      height: 120px;
      padding: 20px;
      display: flex;
      justify-content: space-between;
      background: #54a4ec;
      color: #ffffff;
      .area_box {
        display: flex;
        align-items: center;
        font-size: 28px;
        border: 1px solid;
        border-radius: 20px;
        .van-cell {
          padding: 10px 20px;
          width: 300px;
          border-radius: 20px;
          background-color: unset;
          /deep/.van-cell__value {
            .van-field__body {
              .van-field__control {
                color: #ffffff;
              }
            }
          }
        }
        .van-cell::after {
          border: unset;
        }
        .van-icon {
          margin-right: 20px;
        }
      }
      .show_empty {
        display: flex;
        align-items: center;
        font-size: 28px;
        .van-switch {
          margin-right: 10px;
        }
        .swi_label {
          font-size: 28px;
        }
      }
      /deep/.select_dormtype {
        width: 350px;
        border-radius: 20px;
        .van-dropdown-menu__bar {
          height: 80px;
          border-radius: 20px;
          background: #54a4ec;
          color: #ffffff;
          border: 1px solid;
          .van-dropdown-menu__item {
            .van-dropdown-menu__title {
              color: #ffffff;
            }
          }
        }
      }
    }
    .room_box {
      width: 100%;
      height: calc(100% - 240px);
      overflow-y: auto;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      padding: 20px 20px 0 20px;
      .room_content {
        width: 100%;
        height: 726px;
        margin-bottom: 20px;
        border-bottom: 1px solid #c0c4cc;
        border-radius: 20px;
        .room_title {
          width: 100%;
          height: 80px;
          padding: 20px;
          display: flex;
          border: 1px solid #c0c4cc;
          border-bottom: none;
          border-radius: 20px 20px 0 0;
          background-color: var(--dorm_top_bg_color);
          color: var(--dorm_top_font_color);
          .mark {
            text-align: center;
            font-size: 28px;
          }
          .left_mark {
            width: 20%;
          }
          .middle_mark {
            width: 20%;
            border-left: 1px solid #c0c4cc;
            border-right: 1px solid #c0c4cc;
          }
          .right_mark {
            width: 60%;
          }
        }
        .bed_box {
          height: calc(100% - 80px);
          // padding: 10px;
          font-size: 28px;
          border-left: 1px solid #c0c4cc;
          border-right: 1px solid #c0c4cc;
          border-radius: 0 0 20px 20px;
          // .many_beds::-webkit-scrollbar {
          //   width: 3px !important; /* 对于垂直滚动条 */
          //   height: 3px !important; /* 对于水平滚动条 */
          // }
          .many_beds {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            .bed {
              padding: 20px;
              width: 50%;
              min-height: 160px;
              border-top: 1px solid #c0c4cc;
              position: relative;
              .bed_con {
                width: 100%;
                height: 100%;
                padding: 12px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                border-radius: 12px;
                .van-tag {
                  justify-content: center;
                  background: var(--bed_bg_color);
                  color: var(--bed_font_color);
                }
                .epmname {
                  color: var(--in_bed_empname_font_color);
                }
              }
              .check_in {
                background: var(--in_bed_bg_color);
              }
              .no_check {
                background: var(--not_in_bed_bg_color);
              }
              .empty_box {
                background: var(--empty_bed_bg_color) !important;
              }
            }
            .bed:nth-child(odd) {
              border-right: 1px solid #c0c4cc;
            }
          }
        }
      }
    }
  }
}
</style>